"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoToolbarButtons = exports.VideoWidget = void 0;
var react_1 = __importStar(require("react"));
var useSelectionState_1 = require("Project/QwilrEditor/RegistryElement/useSelectionState");
var Resizer_1 = require("Project/QwilrEditor/RegistryElement/Resizer");
var VideoWidgetEmbedWidget_1 = require("./VideoWidgetEmbedWidget");
var WidgetManager_1 = require("../../WidgetManager");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Video_1 = require("ContentTokens/DataModels/Video");
var Types_1 = require("Tokens/Types");
var lodash_1 = require("lodash");
var inversify_react_1 = require("inversify-react");
var BehaviourBuilder_1 = require("Project/QwilrEditor/Behaviours/BehaviourBuilder");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var styles = __importStar(require("./VideoWidget.css"));
var TokenMenu_1 = require("../TokenMenu/TokenMenu");
var Types_2 = require("@CommonFrontendBackend/Tokens/Types");
var SubstitutionTokenFactory_1 = __importDefault(require("@CommonFrontend/Tokens/SubstitutionTokenFactory"));
var VideoWidget = function (_a) {
    var children = _a.children, element = _a.element;
    var selection = (0, useSelectionState_1.useSelectionState)(element);
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var videoEmbedUrlGenerator = (0, inversify_react_1.useInjection)("videoEmbedUrlGenerator");
    var telemetry = (0, inversify_react_1.useInjection)("editorTelemetry");
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var resizingContext = (0, Resizer_1.useResizerContext)();
    var triggerWidgetEvent = function (eventData) {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("video", eventData));
    };
    var handleDisplayUrlChange = function (displayUrl) { return __awaiter(void 0, void 0, Promise, function () {
        var updateData, embedUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updateData = {
                        action: "update",
                        path: widgetManager.getPath(element),
                    };
                    if (!(displayUrl === "")) return [3, 1];
                    updateData.toUpdate = { displayUrl: displayUrl, embedUrl: "" };
                    widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("video", updateData));
                    return [3, 3];
                case 1:
                    if (!(displayUrl != displayUrl)) return [3, 3];
                    return [4, videoEmbedUrlGenerator.getEmbedUrl(displayUrl)];
                case 2:
                    embedUrl = _a.sent();
                    updateData.toUpdate = { displayUrl: displayUrl, embedUrl: embedUrl };
                    widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("video", updateData));
                    fireVideoAddedTelemetry(embedUrl);
                    _a.label = 3;
                case 3: return [2];
            }
        });
    }); };
    var fireVideoAddedTelemetry = function (embedUrl) {
        telemetry.inlineContentVideoAdded(getVideoSource(embedUrl));
    };
    var getVideoSource = function (embedUrl) {
        if (embedUrl.includes("youtube.com/embed")) {
            return "youtube";
        }
        else if (embedUrl.includes("player.vimeo.com/video")) {
            return "vimeo";
        }
        else if (embedUrl.includes("fast.wistia.net/embed")) {
            return "wistia";
        }
        else if (embedUrl.includes("players.brightcove.net")) {
            return "brightcove";
        }
        else if (embedUrl.includes("loom.com")) {
            return "loom";
        }
        else if (embedUrl.includes("vidyard.com")) {
            return "vidyard";
        }
        return embedUrl;
    };
    var tokensEnabled = checkTokensEnabled(widgetManager, blockStore);
    var instructions = tokensEnabled === Types_1.TokensEnableState.EnabledWithAllInteractions
        ? "Add a video from Youtube, Vimeo, etc, or drag a token in"
        : "Add a video from Youtube, Vimeo, etc, or click to add a token";
    var variableDetails = {
        variable: element.data.variable,
        instructions: instructions,
        icon: icons_1.Video,
    };
    return (react_1.default.createElement(VideoWidgetEmbedWidget_1.VideoWidgetEmbedWidget, { embedUrl: element.data.embedUrl ? (0, Video_1.updateEmbedUrlPrefix)(element.data.embedUrl) : null, displayUrl: element.data.displayUrl, placeholder: react_1.default.createElement(PlaceholderImage, null), placeholderText: "Add a ".concat(supportedVideoTypesAsPhrase, " link"), triggerWidgetEvent: triggerWidgetEvent, handleDisplayUrlChange: handleDisplayUrlChange, errorMsg: "Please add a valid video link from ".concat(supportedVideoTypesAsPhrase), allowVariables: tokensEnabled !== Types_1.TokensEnableState.Disabled || !(0, lodash_1.isUndefined)(element.data.variable), variableDetails: variableDetails, isSelected: selection.widgetSelectionState === "circle", isResizing: resizingContext.resizingEnabled && resizingContext.isResizing, element: element, telemetry: telemetry, widgetManager: widgetManager }, children));
};
exports.VideoWidget = VideoWidget;
var PlaceholderImage = function () { return (react_1.default.createElement("img", { src: "Assets/Images/VideoPlaceholder.svg", className: "video-widget__placeholder-img", draggable: "false" })); };
var supportedVideoTypesAsPhrase = "Youtube, Vimeo, Wistia, Loom, Brightcove or Vidyard";
var checkTokensEnabled = function (widgetManager, blockStore) {
    if (widgetManager.isInTemplate()) {
        return Types_1.TokensEnableState.EnabledWithAllInteractions;
    }
    if (blockStore.isSavedBlock) {
        return Types_1.TokensEnableState.EnabledWithoutDragAndDrop;
    }
    return Types_1.TokensEnableState.Disabled;
};
function VideoToolbarButtons(_a) {
    var _this = this;
    var element = _a.element;
    var _b = __read((0, react_1.useState)(false), 2), showError = _b[0], setShowError = _b[1];
    var _c = __read((0, react_1.useState)(element.data.displayUrl), 2), displayUrl = _c[0], setDisplayUrl = _c[1];
    var supportedVideoTypesAsPhrase = "Youtube, Vimeo, Wistia, Loom, Brightcove or Vidyard";
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var tokensEnabled = checkTokensEnabled(widgetManager, blockStore);
    var allowVariables = tokensEnabled !== Types_1.TokensEnableState.Disabled;
    var variableDetails = {
        instructions: tokensEnabled === Types_1.TokensEnableState.EnabledWithAllInteractions
            ? "Add a video from Youtube, Vimeo, etc, or drag a token in"
            : "Add a video from Youtube, Vimeo, etc, or click to add a token",
        variable: element.data.variable,
    };
    var hasToken = !!variableDetails.variable;
    var triggerWidgetEvent = function (eventData) {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("video", eventData));
    };
    var tokenUtilities = {
        removeToken: function () {
            triggerWidgetEvent({
                action: "update",
                path: widgetManager.getPath(element),
                toUpdate: {
                    variable: null,
                },
            });
        },
        confirmToken: function (token) {
            triggerWidgetEvent({
                action: "update",
                path: widgetManager.getPath(element),
                toUpdate: {
                    variable: token,
                    displayUrl: "",
                    embedUrl: "",
                },
            });
        },
    };
    var onClickTokenButton = function () {
        if (hasToken) {
            tokenUtilities.removeToken();
        }
        else {
            setShowTokenMenu(true);
        }
    };
    var onClickRemoveToken = function () {
        setShowTokenMenu(false);
        tokenUtilities.removeToken();
    };
    var onClickConfirmToken = function (token) {
        tokenUtilities.confirmToken({
            name: token.apiName,
            label: token.name,
            substitutionToken: SubstitutionTokenFactory_1.default.fromLegacyApiToken(token),
        });
    };
    var _d = __read((0, react_1.useState)(!!(variableDetails === null || variableDetails === void 0 ? void 0 : variableDetails.variable)), 2), showTokenMenu = _d[0], setShowTokenMenu = _d[1];
    var usingTokens = allowVariables;
    var handleOnChange = function (url) {
        setDisplayUrl(url);
    };
    var getVideoSource = function (embedUrl) {
        if (embedUrl.includes("youtube.com/embed")) {
            return "youtube";
        }
        else if (embedUrl.includes("player.vimeo.com/video")) {
            return "vimeo";
        }
        else if (embedUrl.includes("fast.wistia.net/embed")) {
            return "wistia";
        }
        else if (embedUrl.includes("players.brightcove.net")) {
            return "brightcove";
        }
        else if (embedUrl.includes("loom.com")) {
            return "loom";
        }
        else if (embedUrl.includes("vidyard.com")) {
            return "vidyard";
        }
        return embedUrl;
    };
    var telemetry = (0, inversify_react_1.useInjection)("editorTelemetry");
    var videoEmbedUrlGenerator = (0, inversify_react_1.useInjection)("videoEmbedUrlGenerator");
    var fireVideoAddedTelemetry = function (embedUrl) {
        telemetry.inlineContentVideoAdded(getVideoSource(embedUrl));
    };
    var handleDisplayUrlChange = function (displayUrl) { return __awaiter(_this, void 0, void 0, function () {
        var updateData, embedUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updateData = {
                        action: "update",
                        path: widgetManager.getPath(element),
                    };
                    if (!(displayUrl === "")) return [3, 1];
                    updateData.toUpdate = { displayUrl: displayUrl, embedUrl: "" };
                    widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("video", updateData));
                    return [3, 3];
                case 1:
                    if (!(element.data.displayUrl != displayUrl)) return [3, 3];
                    return [4, videoEmbedUrlGenerator.getEmbedUrl(displayUrl)];
                case 2:
                    embedUrl = _a.sent();
                    updateData.toUpdate = { displayUrl: displayUrl, embedUrl: embedUrl };
                    widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("video", updateData));
                    fireVideoAddedTelemetry(embedUrl);
                    _a.label = 3;
                case 3: return [2];
            }
        });
    }); };
    var handleUrlSave = function () { return __awaiter(_this, void 0, Promise, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setShowError(false);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, (handleDisplayUrlChange === null || handleDisplayUrlChange === void 0 ? void 0 : handleDisplayUrlChange(displayUrl))];
                case 2:
                    _a.sent();
                    return [3, 4];
                case 3:
                    e_1 = _a.sent();
                    console.log(e_1);
                    setShowError(true);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var handleKeyDown = function (event) {
        if (event.key === BehaviourBuilder_1.KeyType.Enter) {
            handleUrlSave();
        }
    };
    return (react_1.default.createElement(kaleidoscope_1.ErrorTooltip, { size: kaleidoscope_1.TooltipSize.Large, content: "Please add a valid video link from ".concat(supportedVideoTypesAsPhrase), renderTooltip: showError || false },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", align: "center", paddingLeft: "xs", gap: "xxs" },
            !showTokenMenu && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(kaleidoscope_1.TextInput, { label: "Add a ".concat(supportedVideoTypesAsPhrase, " link"), placeholder: "Add a ".concat(supportedVideoTypesAsPhrase, " link"), labelHidden: true, theme: kaleidoscope_1.TextInputTheme.Dark, variant: kaleidoscope_1.TextInputVariant.Borderless, value: displayUrl, onChange: handleOnChange, onKeyDown: handleKeyDown, size: kaleidoscope_1.TextInputSize.XSmall, className: styles.textInput }),
                react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Tick, null), onClick: handleUrlSave, buttonState: kaleidoscope_1.ButtonState.Idle }))),
            showTokenMenu && (react_1.default.createElement("div", { className: "embed-widget__combo-holder" },
                react_1.default.createElement(TokenMenu_1.TokenMenu, { type: Types_2.TokenDataType.String, token: variableDetails.variable, removeToken: onClickRemoveToken, confirmToken: onClickConfirmToken, matchEWRStyling: true, removeEvenWhenEmpty: true, hideConfirmButton: true }))),
            usingTokens && !showTokenMenu && (react_1.default.createElement(kaleidoscope_1.IconButton, { icon: hasToken ? react_1.default.createElement(icons_1.RemoveToken, null) : react_1.default.createElement(icons_1.Tokens, null), onClick: onClickTokenButton })))));
}
exports.VideoToolbarButtons = VideoToolbarButtons;
